import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModuleCard } from '../../Models';
import { MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NgClass, AsyncPipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { SpinnerComponent } from '../../../../../Common/spinner/spinner.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslationPipe } from '../../../../../Services/translation.pipe';

@Component({
    selector: 'aw-module-card',
    templateUrl: './module-card.component.html',
    styleUrls: ['./module-card.component.less'],
    imports: [MatCard, NgClass, ExtendedModule, MatCardTitle, RouterLink, MatIcon, SpinnerComponent, MatCardSubtitle, MatCardContent, MatCardActions, MatButton, MatProgressSpinner, MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem, AsyncPipe, TranslationPipe]
})
export class ModuleCardComponent implements OnInit {
  @Input() module: ModuleCard;
  @Input() syncEnabled = false;
  @Input() disabled = false;
  @Output() reset = new EventEmitter<ModuleCard>();
  @Output() package = new EventEmitter<ModuleCard>();
  creatingPackage = false;

  ngOnInit() {
    this.creatingPackage = false;
  }

  getModuleImageSrc(): string {
    return '../../../../../../assets/img/' + this.module.ModuleId.toLowerCase() + '.svg';
  }

  resetModule() {
    this.reset.emit(this.module);
  }

  createPackage() {
    if (this.creatingPackage) {
      return;
    }
    this.creatingPackage = true;
    this.package.emit(this.module);
  }
}
